import React from 'react';
import { styled } from "../../../stitches.config";

interface SimpleCardsProps {
    children: JSX.Element[];
}

const SimpleCards = ({ children }: SimpleCardsProps) => {
    return (
        <CardsContainer>
            {children}
        </CardsContainer>
    )
}

export default SimpleCards;

const CardsContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    zIndex: 1,
    '@bp4': {
        display: 'flex',
        gap: '24px',
        flexDirection: 'row',
        width: '90%',
        maxWidth: '1440px',
        '& > div': {
            width: '33%',
        }
    }
})
